<template>
    <router-link :to="link">
        <div
            class="rounded-full py-2 px-4 bouton openSans font-bold"
            :class="{ 'contrast': white}"
        >{{ text }}</div>
    </router-link>
</template>

<script>
export default {
    name: "Bouton",
    props: {
        link: String,
        white: { type: Boolean, required: false, default: false },
        text: String
    }
};
</script>

<style scoped lang="scss">
.bouton {
    width: 50%;
    margin: 20px auto;
    padding: 15px;
}
.contrast {
    background-color: #4500b6;
    color: white;
}
</style>
